import Joi from '@hapi/joi'

export const halfNameMarkReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operatin Entity").messages({
        "any.invalid": `Please select valid Operatin Entity`,
        "any.required": `Operatin Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
}